import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=16e6121a&scoped=true&"
import script from "./Card.vue?vue&type=script&lang=js&"
export * from "./Card.vue?vue&type=script&lang=js&"
import style0 from "./Card.vue?vue&type=style&index=0&id=16e6121a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e6121a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ConcertDetailsModal: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/concert/DetailsModal.vue').default})
